export type CustomerOverviewStatInput = {
  lastVisit: string | null;
  totalAppointments: number;
  created_at: string;
};

export function computeCustomerOverviewStats(customers: CustomerOverviewStatInput[]) {
  const now = Date.now();
  const days = (n: number) => n * 24 * 60 * 60 * 1000;

  const total = customers.length;
  const active30 = customers.filter((c) => {
    if (!c.lastVisit) return false;
    return now - new Date(c.lastVisit).getTime() <= days(30);
  }).length;
  const new30 = customers.filter((c) => now - new Date(c.created_at).getTime() <= days(30)).length;
  const noBooking30 = customers.filter((c) => {
    if (!c.lastVisit) return true;
    return now - new Date(c.lastVisit).getTime() > days(30);
  }).length;
  const vip = customers.filter((c) => (c.totalAppointments || 0) >= 5).length;

  return { total, active30, new30, noBooking30, vip };
}
